import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { BaseEventTracking } from '@/modules/core/app/models/abstracts/BaseEventTracking';

export class OnboardingConsentPageViewedEventTracking extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ONBOARDING_CONSENT_PAGE_VIEWED;
  email?: string;
  name?: string;
  jurisdiction?: string;
  redirected_from?: string;
  billing_plan?: string;
  company?: string;

  constructor(eventProperties: Partial<OnboardingConsentPageViewedEventTracking> = {}) {
    super();
    this.email = eventProperties?.email;
    this.name = eventProperties?.name;
    this.jurisdiction = eventProperties?.jurisdiction;
    this.redirected_from = eventProperties?.redirected_from;
    this.billing_plan = eventProperties?.billing_plan;
    this.company = eventProperties?.company;
  }
}
